import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { adminInstance } from '../../config/axios';
import { Button, Label, Form, FormGroup } from 'reactstrap';
import { getAdminData } from '../../reducers/adminReducers';

const PriceIncreaseForm = () => {
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const { loginAdmin, adminSetting } = result || {};
  const { role } = loginAdmin || {};
  const { priceIncreasePercentage } = adminSetting || {};
  const [emptyError, setEmptyError] = useState('');
  const [newPriceIncreasePercentage, setNewPriceIncreasePercentage] = useState(
    priceIncreasePercentage || '0'
  );

  const validatePriceIncrease = (value) => {
    if (value === '') {
      return 'Price Increase Percentage is required';
    }

    if (isNaN(value) || parseFloat(value) <= 0) {
      return 'Price Increase Percentage must be a positive number greater than 0';
    }

    return '';
  };

  const onSubmitHandleData = async (e) => {
    e.preventDefault();

    const error = validatePriceIncrease(newPriceIncreasePercentage);
    setEmptyError(error);

    if (!error) {
      try {
        const payload = {
          priceIncreasePercentage: newPriceIncreasePercentage,
        };

        const response = await adminInstance().put(
          '/api/admin/UpdatePriceIncreasePercentage',
          payload
        );
        const { code, message } = response.data;
        if (code === 200) {
          toast.success(message);
          dispatch(getAdminData());
        } else {
          toast.error(message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <Form className='needs-validation user-add' onSubmit={onSubmitHandleData}>
      <FormGroup className='row justify-content-start mx-0'>
        <div className='admin-input col-xl-5 col-md-7'>
          <Label className='col-form-label pt-0'>
            <span>*</span> Price Increase Percentage
          </Label>
          <input
            className='form-control'
            placeholder='Price Increase Percentage'
            type='number'
            step='0.01'
            value={newPriceIncreasePercentage}
            onChange={(e) => setNewPriceIncreasePercentage(e.target.value)}
          />
          {emptyError && <p className='text-danger'>{emptyError}</p>}
        </div>
      </FormGroup>
      {role?.some((r) =>
        [
          'suUsers',
          'superAdmin',
          'writePriceIncreasePercentage',
          'writePreferences',
        ].includes(r)
      ) && (
        <div className='form-button d-flex justify-content-start pt-3'>
          <Button type='submit' color='primary' className='main-btn'>
            Update
          </Button>
        </div>
      )}
    </Form>
  );
};

export default PriceIncreaseForm;
